import React from "react";
import MobileCard from "ui/pages/SalesAndMarketing/components/MobileCard";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";
import ShareOutlinedIcon from "@material-ui/icons/ShareOutlined";
import { copyToClipboard } from "features/Common/utils/Copy.utils";
import { useNotifications } from "utils/hooks";
import { formatRevenue } from "features/Common/utils/common.utils";

const TrafficAnalysisMobileCard = ({
  record,
  columns,
  onShare,
  onSeeMore,
  isAlternate,
}) => {
  const { notify } = useNotifications();

  const content = columns
    .filter((column) => column.showInCard)
    .map((column) => {
      let value;

      if (column.valueFormatter) {
        value = column.valueFormatter(record);
      } else {
        value = record?.[column.field] ?? column.emptyField ?? "N/A";
      }

      return {
        title: `${column.headerName}:`,
        value,
      };
    });

  return (
    <div className={isAlternate ? "tw-bg-[#F6F6F6]" : ""}>
      <MobileCard
        content={content}
        stats={[
          {
            title: "Leads",
            data: record?.leads ?? 0,
            color: "#086F86",
            icon: "leadIcon.png",
          },
          {
            title: "Bookings",
            data: record?.bookings ?? 0,
            color: "#493AB1",
            icon: "booking.png",
          },
          {
            title: "Revenue",
            data: formatRevenue(record?.total_revenue),
            color: "#1DBE8A",
            icon: "revenue.png",
          },
        ]}
        statColumns={3}
        footer={
          <div className="tw-flex tw-items-center tw-justify-between tw-gap-10 tw-bg-[#EEECF9] tw-w-full tw-px-4 tw-py-4">
            {/* URL */}
            <div className="tw-flex-1 tw-min-w-0">
              <a
                href={record?.url}
                target="_blank"
                rel="noopener noreferrer"
                className="tw-text-[#0052CC] tw-underline tw-text-sm tw-truncate tw-block"
              >
                {record?.url}
              </a>
            </div>

            <div className="tw-flex">
              {/* Copy & Share */}
              <div className="tw-flex tw-items-center tw-gap-3 tw-mx-4">
                <FileCopyOutlinedIcon
                  className="tw-cursor-pointer"
                  style={{ color: "#493AB1" }}
                  fontSize="small"
                  onClick={() => copyToClipboard(record?.url, notify)}
                />

                <ShareOutlinedIcon
                  className="tw-cursor-pointer"
                  style={{ color: "#493AB1" }}
                  fontSize="small"
                  onClick={() => onShare(record)}
                />
              </div>

              {/* See More */}
              <div
                onClick={onSeeMore}
                className="tw-flex tw-items-center tw-gap-1 tw-cursor-pointer"
              >
                <p className="tw-text-[#493AB1] tw-underline tw-m-0">
                  See more
                </p>

                <ArrowForwardIosIcon
                  style={{
                    fontSize: 16,
                    color: "#493AB1",
                  }}
                />
              </div>
            </div>
          </div>
        }
      />
    </div>
  );
};

export default TrafficAnalysisMobileCard;
